export default "__VITE_ASSET__ffe783d0__"